var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main-layout"},[_c('h1',{staticClass:"text-center mt-50"},[(_vm.testing)?_c('span',[_vm._v("\n      Testing Configuration…\n    ")]):_c('span',[_vm._v("\n      Logging In…\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }